import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import { Logout } from '@mui/icons-material';

import { LocalizedLink } from '../../_shared/LocalizedLink';
import { useAuth } from '../../authentication/AuthenticationContext';

export function MenuMobile(): JSX.Element {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  const logout = (): void => {
    auth.logout();
  };

  const data = [
    {
      path: 'my-account',
      translation: 'button.my-account',
    },
    {
      path: 'personal-information',
      translation: 'account.settings.nav.details',
    },
    {
      path: 'communication-preferences',
      translation: 'account.settings.nav.communication',
    },
    {
      path: 'change-password',
      translation: 'account.settings.nav.password',
      requires: auth.user.requiresPassword,
    },
    {
      path: 'mfa',
      translation: 'account.settings.nav.mfa',
    },
  ];

  return (
    <div className='account-menu-mobile'>
      <div className='nav-mobile'>
        <div className='menu-links'>
          {data.map((menuOption) => {
            const fullPath = `/account/${menuOption.path}`;
            if (menuOption.requires == null || menuOption.requires) {
              return (
                <LocalizedLink key={menuOption.path} isNavLink className='menu-link' to={fullPath}>
                  {location.pathname.includes(fullPath) && (
                    <motion.span
                      layoutId='menu-bar-mobile'
                      className='menu-bar'
                      transition={{
                        type: 'spring',
                        duration: 0.5,
                      }}
                    />
                  )}
                  {t(menuOption.translation)}
                </LocalizedLink>
              );
            }
            return null;
          })}
        </div>
      </div>

      <div className='text-center menu-header'>
        <h3>{t('auth.register.sign-up')}</h3>
        <h3 className='username' data-cy='mobile-nickname-text'>
          {auth.user.nickName}
        </h3>
        <button type='button' data-cy='mobile-logout-button' className='btn btn-secondary' onClick={logout}>
          <Logout className='icon' />
          {t('button.logout')}
        </button>
      </div>

    </div>
  );
}
